import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { DeficiencyTicket } from 'src/app/_model/deficiency-ticket';
import { IMSId } from 'src/app/_model/ims-object';

@Injectable()
export abstract class DeficiencyTicketsDaoService implements Resetable {
  public abstract saveDeficiencyTickets(deficiencyTickets: DeficiencyTicket[]): Promise<void>;
  public abstract createDeficiencyTicket(deficiencyTicket: DeficiencyTicket): Promise<DeficiencyTicket>;
  public abstract getDeficiencyTickets(): Promise<DeficiencyTicket[]>;
  public abstract deleteLocalDeficiencyTicket(id: IMSId): Promise<void>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
  public abstract clearRemoteDeficiencyTickets(): Promise<void>;
}
